import backendAxios from './backendAxios';

const setAuthToken = token => {
  if(token) {
    backendAxios.defaults.headers.common['x-auth-token'] = token;
  } else {
    delete backendAxios.defaults.headers.common['x-auth-token'];
  }
  return backendAxios
}

export default setAuthToken;